import { AppState } from '../root.reducer';

export const getIsShowingSearchModal = (state: AppState) => state.addressHistory.isShowingSearchModal;
export const getIsAddNewFormOpen = (state: AppState) => state.addressHistory.isAddNewFormOpen;
export const getSearchedAddresses = (state: AppState) => state.addressHistory.searchedAddresses;
